// extracted by mini-css-extract-plugin
export var arrows = "_8w-6";
export var decrementer = "_8w-a";
export var disabled = "_8w-4";
export var error = "_8w-1";
export var hiddenText = "_8w-b";
export var incrementer = "_8w-9";
export var input = "_8w-8";
export var inputWrapper = "_8w-0";
export var leadingIcon = "_8w-c";
export var readonly = "_8w-3";
export var regular = "_8w-7";
export var small = "_8w-5";
export var warning = "_8w-2";